var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhantom = function SvgPhantom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 34"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#3A31A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#phantom_svg__a)",
    d: "M29.17 17.207h-2.997c0-6.107-4.968-11.058-11.097-11.058-6.053 0-10.975 4.83-11.095 10.832-.125 6.205 5.717 11.593 11.945 11.593h.783c5.491 0 12.85-4.282 14-9.5.212-.963-.55-1.867-1.539-1.867m-18.548.272c0 .817-.67 1.485-1.49 1.485s-1.49-.668-1.49-1.485v-2.402c0-.816.67-1.484 1.49-1.484s1.49.668 1.49 1.484zm5.174 0c0 .817-.67 1.485-1.49 1.485s-1.49-.668-1.49-1.485v-2.402c0-.816.67-1.484 1.49-1.484s1.49.668 1.49 1.484z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "phantom_svg__a",
    x1: 17.362,
    x2: 17.362,
    y1: 6.149,
    y2: 28.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.82
  })))));
};
export { SvgPhantom as ReactComponent };